import React from "react";
import { useState, useEffect } from "react";


export const Pagination = (props) => {

  const { onPageChange, displayPageOutOfTotal } = props
  let totalPages = props.totalPages
  const [numberOfPages, setnumberOfPages] = useState([])
  const [pageNumber, setPageNumber] = useState(1);


  useEffect(() => {
    setnumberOfPages(totalPages)
    // eslint-disable-next-line
  }, [props]);


  useEffect(() => {
    if (props.currentPage === 0) {
      setPageNumber(1)
    } else {
      setPageNumber(props.currentPage)

    }
    // eslint-disable-next-line
  }, [props.currentPage]);


  const handlepageselection = (item) => {
    onPageChange(item + 1)
    setPageNumber(item + 1)
  };

  const onNext = (item) => {
    if (item < numberOfPages) {
      onPageChange(item + 1)
      setPageNumber(item + 1)
    }
  }

  const onPrevious = (item) => {
    if (!(item <= 1)) {
      onPageChange(item - 1)
      setPageNumber(item - 1)
    }

  }


  const PAGE_GROUP_SIZE = 10;

  const currentGroup = Math.floor((pageNumber - 1) / PAGE_GROUP_SIZE);

  const startPage = currentGroup * PAGE_GROUP_SIZE + 1;
  const endPage = Math.min(startPage + PAGE_GROUP_SIZE - 1, totalPages);

  const visiblePages = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );


  return (
    <div className="pagination container-fluid">
      <div className="row align-items-center">
        <div className="col-9">
          <div className="pagination-btn c-pointer" id={pageNumber} value={pageNumber} onClick={() => onPrevious(pageNumber)} disabled={pageNumber === 1}>&laquo;</div>
          {/* {Array.from({ length: Number(numberOfPages) }, (_, i) => {
            // if (i + 1 !== pageNumber) return null;
             return(
            <span key={i}>
              <div className={`pagination-btn c-pointer ${i === pageNumber - 1 ? 'active' : ''}`} onClick={() => handlepageselection(i)}>{i + 1}</div>
            </span>
             )
          })} */}
          {visiblePages.map((page) => (
            <span key={page}>
              <div className={`pagination-btn c-pointer ${page === pageNumber ? "active" : ""}`} onClick={() => { onPageChange(page); setPageNumber(page); }} >{page}</div>
            </span>
          ))}
          <div className="pagination-btn c-pointer" id={pageNumber} value={pageNumber} onClick={() => onNext(pageNumber)} disabled={pageNumber === totalPages}>&raquo;</div>
        </div>
        <div className="col-3">
          <div className="paginations mt-0">
            <p style={{ fontWeight: 700 }}>  {displayPageOutOfTotal} </p>
          </div>
        </div>
      </div>
    </div>
  )

}

export default Pagination;